import { BaSeDialogContext, BaSeTheme } from '@base/react';
import React from 'react';
import CreateNewRegional from '../dialogs/create-new-regional';
import EditRegional from '../dialogs/edit-regional';

export const useReginal = () => {
  const { showModal } = React.useContext(BaSeDialogContext);

  const openDialogNewRegional = React.useCallback(
    (fetchRegional) => {
      return showModal({
        actions: [],
        size: 'medium',
        title: 'Criar regional',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <CreateNewRegional closeModal={closeModal} />
        ),

        onChooseAction: (action) => {
          fetchRegional({
            filter: {
              sortField: 'REGIONAL_NAME',
              sortType: 'DESC',
            },
          });
          if (action === 'new') {
            setTimeout(() => {
              openDialogNewRegional();
            }, 1500);
          }
        },
      });
    },
    [showModal],
  );

  const openDialogEditRegional = React.useCallback(
    (fetchRefional) => {
      return showModal({
        actions: [],
        size: 'medium',
        title: 'Editar regional',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <EditRegional closeModal={closeModal} fetchRefional={fetchRefional} />
        ),
        onChooseAction: (action) => {
          fetchRefional();
        },
      });
    },
    [showModal],
  );
  return { openDialogNewRegional, openDialogEditRegional };
};
